<template>
	<div class="brandContainer">
		<!-- 导航 -->
		<div class="navBar">
			<img class="navLogo" src="../assets/logo2.png" alt="">
				<ul class="navBarItem">
					<!-- <li class="busiz-active-sel"><router-link exact to="/" tag="a">首页</router-link></li> -->
					<li><router-link to="/aboutlanshu" exact tag="a">关于兰树</router-link></li>
					<el-dropdown>
							<li class="brandLi"><router-link exact to="/brand" style="font-size: 0.9em;"  tag="a">兰树品牌</router-link></li>
								<el-dropdown-menu class="elDropdown" exact slot="dropdown" style="background:rgb(236,245,255)!important;">
									<el-dropdown-item><li @click="chooseBrand(1)"><router-link :class="brandActive == '1'? 'elDropdown_active':''"  style="background:rgb(236,245,255) !important; color: #000 !important;"  to="/brand" tag="a">淮树</router-link></li></el-dropdown-item>
									<el-dropdown-item><li @click="chooseBrand(2)"><router-link :class="brandActive == '2'? 'elDropdown_active':''"  style="background:rgb(236,245,255) !important; color: #000 !important;"  to="#" tag="a">心清堂</router-link></li></el-dropdown-item>
									<el-dropdown-item><li @click="chooseBrand(3)"><router-link :class="brandActive == '3'? 'elDropdown_active':''"  style="background:rgb(236,245,255) !important; color: #000 !important;" to="#" tag="a">水姻缘</router-link></li></el-dropdown-item>
									<el-dropdown-item><li @click="chooseBrand(4)"><router-link :class="brandActive == '4'? 'elDropdown_active':''"  style="background:rgb(236,245,255) !important; color: #000 !important;" to="#" tag="a">一清堂</router-link></li></el-dropdown-item>
									<el-dropdown-item><li @click="chooseBrand(5)"><router-link :class="brandActive == '5'? 'elDropdown_active':''"  style="background:rgb(236,245,255) !important; color: #000 !important;" to="#" tag="a">Dr.CHUNG<span style="vertical-align: super;">+</span></router-link></li></el-dropdown-item>
								</el-dropdown-menu>
						</el-dropdown>
					<li><router-link to="/park" exact tag="a">智慧园区</router-link></li>
					<li><router-link to="/brandLanshu" exact tag="a">美业菩提</router-link></li>
					<li><router-link to="/school" exact tag="a">兰树商学院</router-link></li>
					
					<li><router-link to="/dynamicLanshu" exact tag="a">菩提基金会</router-link></li>
						
					<li><router-link to="/lanshuTrends" exact tag="a">兰树动态</router-link></li>
				</ul>
			</div>
			
		 
		<div :data-id="item.id" :class="item.id == brandActive ? 'block' : 'none'" class="brandBox" v-for="(item,index) in brandData" :key="index">	 
			<div class="brandHeader">
				<img class="brandLogo" src="../assets/brand/huaishuLogo.png" alt="">
				<li class="brandNav1"><a href="#">品牌故事</a></li>
				<li class="brandNav1" @click="enterProducts(item.id)"><router-link style="background:none !important;" to="#" tag="a">{{item.topNavBar}}</router-link></li>
			</div>
			
			<div class="brandBg">
				<img class="brandBgImg" src="../assets/brand/huaishuBg.png" alt="">
			</div>
			
			
			<div class="brandMainBox">
				<div class="brandMainBoxMiddle">
					<img class="brandItemImg1" src="../assets/brand/huaishuItem1.png" alt="">
					<div class="brandTitleBox">
						<div class="brandTitle">品牌起源</div>
						<div class="brandText1">{{item.originText1}}</div>
						<div class="brandText2">{{item.originText2}}</div>
					</div>
				</div>
			</div>
			
		<div class="brandmainBox2">
			<div class="brandMainBoxMiddle2">
				<div class="brandTitleBox2">
					<div class="brandTitle">品牌理念</div>
					<div class="brandText">{{item.ideaText1}}</div>
				</div>
				<img class="brandItemImg2" src="../assets/brand/huaishuItem2.png" alt="">
			</div>
		</div>
		
		<div class="brandMainBox">
				<div class="brandMainBoxMiddle">
						<img class="brandItemImg1" src="../assets/brand/huaishuItem3.png" alt="">
						<div class="brandTitleBox">
						<div class="brandTitle">品牌特色</div>
						<div class="brandText">{{item.charText1}}</div>
				</div>
			</div>
	</div>
	
	
	
	<div class="brandItemBox">
		<img class="brandItem brandItem1" src="../assets/brand/huaishuImg1.png" alt="">
		<img class="brandItem brandItem2" src="../assets/brand/huaishuImg2.png" alt="">
		<img class="brandItem brandItem3" src="../assets/brand/huaishuImg3.png" alt="">
		<img class="brandItem brandItem4" src="../assets/brand/huaishuImg4.png" alt="">
		<img class="brandItem brandItem5" src="../assets/brand/huaishuImg5.png" alt="">
	</div>
	
	
	<div class="brandAdviserBox">
		<!-- <div class="adviserMiddle">

		</div> -->
		<div class="adviserTitle1">淮树-皮肤美丽顾问</div>
		<div class="adviserTitle2">以“君臣佐使”为主方理念，结合东方护肤哲学，现代护肤哲学，调节肌肤“油水平衡”。</div>
	</div>
	</div>
		
		<!-- 底部 -->
		<div class="footerOuter">	
			<div class="footerBox">
				<div class="footerBoxHeader">
						<div class="footerBoxHeaderLeft">
							<img class="codeImg" src="../assets/code.png" alt="">
							<span class="codeText">兰树公众号</span>
						</div>
						<div class="footerBoxHeaderRight">
							<img class="codeImg" src="../assets/code.png" alt="">
							<span class="codeText">兰树云小程序</span>
						</div>
						  					<div class="footerBoxHeaderRight">
						  						<img class="codeImg" src="../assets/code.png" alt="">
						  						<span class="codeText">兰树客服(QQ)</span>
						  					</div>
						  
				</div>
						  			<div class="footerMainBox">
						  				<li class="footerShop"><a>淮树旗舰店</a></li>
						  				<li class="footerShop"><a>心清堂旗舰店</a></li>
						  				<li class="footerShop"><a>水姻缘旗舰店</a></li>
						  				<li class="footerShop"><a>一清堂旗舰店</a></li>
						  				<li class="footerShop"><a >Dr.CHUNG<span style="vertical-align: super;">+</span>旗舰店</a></li>
						  				<div class="lastHeader">
						  					<li><a href="#">登录</a></li>
						  					|
						  					<li><a href="#">注册</a></li>
						  				</div>
						  			</div>
						  			
						  			<div class="footerInfoBox">
						  				<div class="emailBox">邮箱:  postermaster@lasur.com</div>
						  				<div class="phoneBox">电话:  0571-89025888</div>
						  				<div class="addressBox">地址:  浙江省杭州市之江东路越秀·维多利中心A座 17楼</div>
						  			</div>
						  			
						  			
						  			
				<div class="footerLine"></div>
				<div class="footerBoxBottom">
						<div class="footerLeft">
							Copyright © 2020 兰树化妆品股份有限公司 <a href="https://beian.miit.gov.cn/#/Integrated/index">浙ICP备20018890号-1</a> | 
							<img height="16px" src="../assets/plice.png"/>&nbsp;<a target="_blank"  href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33052102000740">浙公网安备 33052102000740号</a>
						</div>
				</div>
				
			</div>
			</div>
			
	</div>
</template>

<script>
	export default{
		data(){
			return{
				brandActive:1,
				brandData:[
					{
						id:1,
						topNavBar:'淮树产品',
						originText1:'淮|水为智，其性聪，其情善。树|木为仁，其性直，其情和。淮树|源于自然生生不息的生命智慧。',
						originText2:'淮树————从自然中汲取灵感，启迪智慧，运用现代科技凝练植物菁萃，赋予肌肤健康活力，为爱美人士提供安全有效的纯净美肌方案。',
						ideaText1:'以"阴阳平衡"的东方哲学概念为根本，融合现代"水油平衡"的护肤理念，打造自然、平衡的护肤新潮流。',
						charText1:'天然草本，护肤之源；"君臣佐使"组方要义；"预防、保养、修护"三效合一；皮肤的黄金搭档。'
					},
					{
						id:2,
						topNavBar:'心清堂产品',
						originText1:'紧随"科技护肤"的行业新潮流，创立心清堂，用科技赋能美业，潜心打造安全性、功效性、针对性强的护肤品。',
						originText2:'安全有效的纯净美肌方案。',
						ideaText1:'秉持"中学为体、西学为用"的品牌发展理念，将西方科技融入东方智慧，以植物生命能量修护肌肤功能，用生物科技修护肌肤结构，用科技引领护肤新体验。',
						charText1:'以三种西方核心技术，萃取植物中的高活性物质，释放小分子水润护肤能量，深入肌底，唤醒肌肤健康活力。'
					},
					{
						id:3,
						topNavBar:'水姻缘产品',
						originText1:'水是生命之本源，善利万物，于肌肤亦是如此。"以水养护，姻水结缘"，与爱美人士追求的纯真爱情的精神内核相契合，水姻缘品牌由此而来。',
						originText2:'品牌创始人旨在将东方的美学及意识与西方的技术及商业实践相结合，将先进技术与植 物菁萃融合，用大自然的生命智慧打造肌肤健康，力求为广大爱美人士提供更为安全有 效的纯净美肌方案。',
						ideaText1:'遵循东方美的协调法则，溯源水的至纯至净，以水之精华润养肌肤，调节水油平衡，激发肌肤本源之美，悦享水润舒爽的护肤之旅。',
						charText1:'以水养护，姻水结缘；绿色汉草注能，生命能量护肤；修护、保养、预防三效合一。'
					},
					{
						id:4,
						topNavBar:'一清堂产品',
						originText1:'世间万般，镜花水月，得失成败，一切随缘出世之心,入世之身，一身清净，万般自在，曰：一清堂。',
						originText2:'一清堂即是由兰树企业创始人钟鸣先生由此首诗句发想而来，以期每一位爱美人士，能在舒适的护肤体验中，修得身、心、灵的清净、平和与从容。',
						ideaText1:'奉行中药行修和无人见，存心有天知、炮制虽繁必不敢省人工，品味虽贵必不敢减物力的两大原则，严格遵循国家规定，精选上乘原料、研制优质产品，多方位修护问题性肌肤，重现肌肤自然美、平衡美、活力美。',
						charText1:'修有道，养有方；草本提取，植本清芳；修护、预防、保养三合一。'
					},	
					{
						id:5,
						topNavBar:'Dr.CHUNG<span style="vertical-align: super;">+</span>产品',
						originText1:'孕育新生，也要守护美丽，为了守护女性孕期肌肤，呵护宝宝成长时刻时的娇嫩肌肤，我们将植本精粹与科学理论相结合，创立Dr.CHUNG+孕婴童护肤品牌。',
						originText2:'品牌创始人旨在将东方的美学及意识与西方的技术及商业实践相结合，将先进技术与植 物菁萃融合，用大自然的生命智慧打造肌肤健康，力求为广大爱美人士提供更为安全有 效的纯净美肌方案。',
						ideaText1:'集蕴自然草本菁华，以科学的皮肤知识为指导，悉心呵护宝宝的娇嫩肌肤，为孕妈带去安心的护肤的体验。',
						charText1:'天然亲肤，安全舒适；科学为证，专业养肤；"孕前防护、孕中保护、孕后修护"三效合一；皮肤的黄金搭档。'
					}
				]
			}
		},
		created(){
			
		},
		methods:{
			chooseBrand(opction){
				let that = this;
				this.brandActive = opction;
				console.log("opction",opction);
				// this.brandData.forEach(item =>{
				// 	if(item[opction-1].id == opction){
				// 		item[opction-1].chooseNumber = 1;
				// 	}else{
				// 		item[opction-1].chooseNumber =2;
				// 	}
				// })
			},
			enterProducts(id){
				// 进入商品列表
				this.$router.push({path:'/productsList',query:{userId:id}})
			}
		}
	}
	
	// 鼠标滚动到指定位置时 触发动画
	// $(window).scroll(function(){
	// 	var scroll =$(window).scrollTop();
	// 	    console.log(scroll);
	// 		if(scroll > 600){
				
	// 		}
	// 	})
	
</script>

<style scoped>
	
	/* 下拉菜单栏 选中 */	
	.elDropdown_active{
		background-color:#FFFFFF !important;
		color:#000000 !important;
	}
	
	
	
	.brandContainer{
		position:absolute;
		height: 100%;
		width: 100%;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
	}
	
	
	
	 /* 导航 */
	.navBar{
		width: 100%;
		display: flex;
		flex-direction: row;
		align-items: center;
		position: absolute;
		justify-content: space-between;
		top: 0;
		background: #FFFFFF;
		/* border-bottom:1px solid rgba(255,255,255,0.2); */
		z-index: 999;
	}
	
	.router-link-active {
	   background-color:#0F3F93 !important; 
	   color: #FFFFFF !important;
	  }
	
	.navLogo{
		width: 10%;
		margin-left: 5em;
	}
	
	.navBarItem{
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-end;
	}
	
	
	.navBarItem li{
		/* list-style: none;
		padding: 1.5em 2.5em 1.5em 2.5em;
		float: left; */
		list-style: none;
		/* padding: 25px 40px 25px 40px; */
		float: left;
		/* margin-left: 2em; */
	}
	
	.brandLi a{
		text-decoration: none;
		font-size:0.875em;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #222222;
		line-height: 20px;
		padding-top:1.6em !important;
		padding-bottom: 1.6em !important;
		padding-left: 2em;
		padding-right: 2em;	
	}
	
	.navBarItem li a{
		text-decoration: none;
		font-size:0.875em;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #222222;
		line-height: 20px;
		padding-top:1.4em;
		padding-bottom: 1.4em;
		padding-left: 0.8rem;
		padding-right: 0.8rem;
	}
	
	/* .elDropdown{
		margin-left: -7.5em;
		margin-top: -1em;
	} */
	
	.elDropdown a {
		color: #111111;
		text-decoration: none;
	}
	
	.el-dropdown {
	    vertical-align: top;
	  }
	  .el-dropdown + .el-dropdown {
	    margin-left: 15px;
	  }
	  .el-icon-arrow-down {
	    font-size: 12px;
	  }
	  
	  .el-dropdown-link {
	    cursor: pointer;
	  }
	  .el-icon-arrow-down {
	    font-size: 12px;
	  }
	  
	  .brandMainBox{
		width: 100%;
		background-color: #F6F6F6;
	  }
	  
	  
	  .brandmainBox2{
		  width: 100%;
		  background: #E9E9E9;
	  }
	  
	  
	  .brandMainBoxMiddle{
		  display: flex;
		  flex-direction: row;
		  width: 70%;
		  margin: 0 auto;
		  padding-top: 4em;
		  padding-bottom: 4em;
	  }
	  
	  .brandMainBoxMiddle2{
		   display: flex;
		  flex-direction: row;
		  width: 70%;
		  margin: 0 auto;
		  padding-top: 3em;
	  }
	  
	
	.brandHeader{
		display: flex;
		flex-direction:row;
		width: 100%;
		margin: 0 auto;
		margin-top: 3em;
		text-align: center;
		background: #439647;
		height: 50px;
		align-items: center;
		justify-content: center;
	}
	
	
	.brandNav1{
		list-style: none;
		padding:0 3em 0 3em;
	}
	
	
	.brandNav1 a{
		text-decoration: none;
		font-size:0.875em;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #FFFFFF;
		line-height: 20px;
	}
	
	.brandLogo{
		width: 28px;
		margin-right: 6em;
	}
	
	.brandBg{
		width: 100%;
	}
	
	.brandBgImg{
		width: 100%;
		height:55%;
	}
	
	
	.brandItemImg1{
		width: 25%;
		position:relative;
		left:0;
		animation: branditemimg1 1s;
		-webkit-animation: branditemimg1 1s;/* Safari 和 Chrome */
	}
	

	/* branditemimg1 动画效果 */
	  @keyframes branditemimg1 {
	  	from{opacity: 0;
		   left: -30em;}
	  	to{opacity: 1;
		   left:0;}
	  }
	  
	  
	  @-webkit-keyframes branditemimg1 
	{
	from {opacity: 0;
		  left: -30em;}
	to {opacity: 1;
		  left:0;}
	}
	
	
	.brandItemImg2{
		width: 40%;
		position: relative;
		left: 3em;
		top: -6em;
		animation: branditemimg2 1s;
		-webkit-animation: branditemimg2 1s;	/* Safari 和 Chrome */
	}
	
	/* branditemimg2 动画效果 */
	  @keyframes branditemimg2 {
	   from{opacity: 0;
			 width: 0;
			 left: 15em;}
	  	to{opacity: 1;
		     width: 40%;
		     left:3em;}
	  }
	  
	  @-webkit-keyframes branditemimg2 
	{
	from {opacity: 0;
		  width: 0;
		  left: 15em;}
	to {opacity: 1;
		  width: 40%;
		  left:3em;}
	}
	
	
	.brandTitleBox{
		width: 70%;
		display: flex;
		flex-direction: column;
		left:2em;
		position: relative;
		animation: brandtitlebox 1s;
		-webkit-animation: brandtitlebox 1s;	
	}
	
	
	/* brandtitlebox 动画效果 */
	  @keyframes brandtitlebox {
	  	from{opacity: 0;
			 left:20em;}
	  	to{opacity: 1;
		   left:2em;}
	  }
	  
	  @-webkit-keyframes brandtitlebox 
	{
	from {opacity: 0;
		  left:20em;}
	to {opacity: 1;
		   left:2em;}
	}
	
	
	.brandTitleBox2{
		width: 70%;
		display: flex;
		flex-direction: column;
		position: relative;
		left:0;
		animation: brandtitlebox2 1s;
		-webkit-animation: brandtitlebox2 1s;
	}
	
	
	
	/* brandtitlebox2 动画效果 */
	  @keyframes brandtitlebox2 {
	  	from{opacity: 0;
			left:-40em;}
	  	to{opacity: 1;
		    left: 0;}
	  }
	  
	  @-webkit-keyframes brandtitlebox2
	{
	from {opacity: 0;
		    left:-40em;}
	to {opacity: 1;
		    left: 0;}
	}
	
	
	
	.brandText{
		font-size:0.875em;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #333333;
		line-height: 20px;
		margin-top: 1em;
	}
	
	.brandTitle{
		margin-top: 1em;
		font-size:1.625em;
		font-family: MicrosoftYaHei;
		color: #000000;
		line-height: 35px;
	}
	
	.brandText1{
		font-size:0.875em;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #333333;
		line-height: 20px;
		margin-top: 2em;
	}
	
	.brandText2{
		font-size:0.875em;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #333333;
		line-height: 20px;
		margin-top: 1em;
	}
	
	.brandItemBox{
		width: 100%;
		background-color: #E1E1E1;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-around;
		padding-top: 2em;
		padding-bottom: 2em;
	}
	
	.brandAdviserBox{
		width: 100%;
		display: flex;
		flex-direction:column;
		align-items: center;
		padding-top: 2em;
		padding-bottom: 2em;
		text-align: center;
		background: url(../assets/brand/adviserBg.png) no-repeat;
		background-size: 100% 100%;
		height:240px;
		opacity:1;
		/* animation: brandadviserbox 10s;
		-webkit-animation: brandadviserbox 10s; */
	}
	
	
	/* brandadviserbox动画效果 */
	 /* @keyframes brandadviserbox {
	  	from{opacity:0.2;}
	  	to{opacity: 1;}
	  }
	  @-webkit-keyframes brandadviserbox 
	{
	from {opacity: 0.2;}
	to {opacity: 1;}
	}
	 */
	
	.adviserTitle1{
		font-size:1.625em;
		font-family: MicrosoftYaHei;
		color: #111111;
		line-height: 35px;
		position: relative;
		top: 3em;
		left:0;
		animation: advisertitle1 1s;
		-webkit-animation: advisertitle1 1s; 
	}
	
	
	
	/* advisertitle1 动画效果 */
	 @keyframes advisertitle1 {
	  	from{
			opacity:0;
			left:-25em;
		}
	  	to{
			opacity: 1;
			left: 0;
		}
	  }
	  
	 @-webkit-keyframes advisertitle1 
	{
	from {
		opacity: 0;
		left:-25em;
		}
	to {
		opacity: 1;
		left: 0;
		}
	}
	
	
	
	.adviserTitle2{
		font-size:1em;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #111111;
		line-height: 22px;
		position: relative;
		top: 6em;
		left:0;
		animation: advisertitle2 1s;
		-webkit-animation: advisertitle2 1s;
	}
	
	
	/* advisertitle2 动画效果 */
	 @keyframes advisertitle2 {
	  	from{
			opacity:0;
			left:30em;
		}
	  	to{
			opacity: 1;
			left: 0;
		}
	  }
	  
	  
	  
	 @-webkit-keyframes advisertitle2 
	{
	from {
		opacity: 0;
		left:30em;
		}
	to {
		opacity: 1;
		left:0;
		}		
	}
	
	
	/* .adviserMiddle{
		width: 80%;
		margin: 0 auto;
	}
	 */
	
	
	/* footer */
	 .footerBox{
	 	width:90%;
	 	/* height: 287px; */
	 	background:#F8F9FB;
	 	/* position:absolute;
	 	bottom:0; */
		margin: 0 auto;
	 	flex-direction: column;
	 	z-index: 999;
			margin-top: 1rem;
	 }
	 
	 
	 .footerOuter{
			  width: 100%;
			  margin: 0 auto;
			  display: flex;
			  flex-direction: column;
			  align-items: center;
			  background-color: #F8F9FB;
	 }
	  
	 .footerBoxHeader{
	 	margin: 0 auto;
	 	display: flex;
	 	flex-direction: row;
	 	align-items: center;
	 	justify-content: center;
	 	margin-top: 2%;
	 }
	 
	 
	 .footerBoxHeaderLeft{
	 	display: flex;
	 	flex-direction: column;
	 	align-items: center;
	 }
	 
	 .footerBoxHeaderRight{
	 	display: flex;
	 	flex-direction: column;
	 	align-items: center;
		margin-left: 5em;
	 }
	 
	 .footerBoxHeaderMiddle{
	 	display: flex;
	 	flex-direction: column;
	 	align-items: center;
	 }
	 
	 .codeImg{
	 	width:100%;
	 }
	 
	 .codeText{	
	 font-size: 0.88em;
	 font-family: PingFangSC-Regular, PingFang SC;
	 font-weight: 400;
	 color: #666666;
	 line-height: 20px;
	 /* margin-top: 0em; */
	 }
	 
	 
	 
	 .footerLine{
	 	width: 79%;
	 	height: 1px;
	 	display: flex;
	 	background: #000000;
	 	opacity: 0.1;
	 	margin: 0 auto;
	 	align-items:center;
	 	margin-top: 1em;
	 }
	 
	 
	 
	 .footerInfoBox{
		 display: flex;
		 flex-direction: column;
		 align-items: center;
		 margin-top: 2rem;
	 }
	 
	 .emailBox{
		 font-size:0.875rem;
		 font-family: PingFangSC-Regular, PingFang SC;
		 font-weight: 400;
		 color: #222222;
		 line-height: 20px;
	 }
	 
	 
	 
	 .phoneBox{
		 font-size:0.875rem;
		 font-family: PingFangSC-Regular, PingFang SC;
		 font-weight: 400;
		 color: #222222;
		 line-height: 20px;
		 margin-top: 0.5rem;
	 }
	 
	 .addressBox{
		font-size:0.875rem;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #222222;
		line-height: 20px;
		margin-top: 0.5rem;
	 }
	 
	 
	 .footerBoxBottom{
	 	display: flex;
	 	margin: 0 auto;
	 	align-items: center;
	 	flex-direction: row;
	 	justify-content: center;
	 	margin-top: 1rem;
	 }
	 
	 
	 
	 .footerLeft{
	 font-size:0.875em;
	 font-family: PingFangSC-Regular, PingFang SC;
	 font-weight: 400;
	 color: #666666;
	 line-height: 24px;
	 }
	 
	 
	 .footerLeft a{
	 		 text-decoration: none;
	 		 cursor: pointer;
	 		 color: #666666;
	 }
	 
	 .footerLeft a:hover{
	 		 color:#003F98;
	 }
	 
	 
	 
	 .footerMiddle{
	 	display: flex;
	 	flex-direction: column;
	 	margin-left: 1em;
	 }
	 
	 .footerMiddle span{
	 font-size: 0.875em;
	 font-family: PingFangSC-Regular, PingFang SC;
	 font-weight: 400;
	 color: #666666;
	 line-height: 24px;
	 }
	 
	 .footerRight{
	 	display: flex;
	 	flex-direction: column;
	 	margin-left: 1em;
	 }
	 
	 .footerRight li a{
	 	text-decoration: none;
	 	font-size:0.875em;
	 	font-family: PingFangSC-Regular, PingFang SC;
	 	font-weight: 400;
	 	color: #666666;
	 	line-height: 28px;
	 }
	 
	 .footerRight li{
	 	list-style: none;
	 }
	 
	 .footerLast{
	 	display: flex;
	 	flex-direction: column;
	 	margin-left: 1em;
	 }
	 
	 .lastHeader{
	 	display: flex;
	 	flex-direction: row;
	 	font-size:0.875em;
	 	font-family: PingFangSC-Regular, PingFang SC;
	 	font-weight: 400;
	 	color: #666666;
	 	line-height: 28px;
		margin-left: 2em;
	 }
	 
	 .lastHeader li a {
	 	text-decoration: none;
	 	font-size:0.875rm;
	 	font-family: PingFangSC-Regular, PingFang SC;
	 	font-weight: 400;
	 	color: #222222;
	 	line-height: 28px;
	 }
	 
	 .lastHeader li {
	 	list-style: none;
	 }
	 
	 .footerLast span{
	 	font-size:0.875em;
	 	font-family: PingFangSC-Regular, PingFang SC;
	 	font-weight: 400;
	 	color: #666666;
	 }
	 
	 .footerMainBox{
		 display: flex;
		 flex-direction: row;
		 margin: 0 auto;
		 align-items: center;
		 flex-direction: row;
		 justify-content: center;
		 margin-top: 2em;
	 }
	 
	 
	 
	.footerShop{
		list-style:none;
	}
	
	 .footerShop a{
		 text-decoration: none;
		 font-size:0.875rem;
		 font-family: PingFangSC-Regular, PingFang SC;
		 font-weight: 400;
		 color: #222222;
		 padding-left: 3em;
		 line-height: 28px; 
	 }
	
	
	/* .brandBox{
		display: none;
	} */
	
	.block{
		display: block;
	}
	
	.none{
		display: none;
	}

</style>



// WEBPACK FOOTER //
// src/components/Brand.vue